import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { METROLOGY_MODULE } from '../../configs/moduleNames';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const LOAD_METROLOGY_DATA = '_LOAD_METROLOGY_DATA';
export const SAVE_METROLOGY = '_SAVE_METROLOGY';

export const loadMetrologyData = createDeferredAction(METROLOGY_MODULE + LOAD_METROLOGY_DATA);
export const loadMetrologyDataSuccessful = createAction(METROLOGY_MODULE + LOAD_METROLOGY_DATA + SUCCESSFUL);
export const loadMetrologyDataFailed = createAction(METROLOGY_MODULE + LOAD_METROLOGY_DATA + FAILED);

export const saveMetrology = createDeferredAction(METROLOGY_MODULE + SAVE_METROLOGY);
export const saveMetrologySuccessful = createAction(METROLOGY_MODULE + SAVE_METROLOGY + SUCCESSFUL);
export const saveMetrologyFailed = createAction(METROLOGY_MODULE + SAVE_METROLOGY + FAILED);
